import { Injectable } from '@angular/core';
import { SyncData } from '../../entities/sync-data';
import { LocalDbService } from '../local-db-service';

@Injectable({ providedIn: 'root' })
export class SyncDataRepository {
  private static readonly syncDataId = 'sync-data';

  private get table() {
    return this.db.syncDataTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async get(): Promise<SyncData | undefined> {
    const row = await this.table.get(SyncDataRepository.syncDataId);
    return row ? new SyncData(row) : undefined;
  }

  async save(data: Partial<SyncData>): Promise<void> {
    const current = await this.get();

    await this.table.put(new SyncData({
      ...current,
      ...data,
      id: SyncDataRepository.syncDataId,
    }));
  }
}
